import { useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./Modal.module.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../button/PrimaryButton";
import SecondaryButton from "../button/SecondaryButton";
import { GROLOG_URL } from "../../constant/apiConstant";
import ModalSuccessDelete from "./ModalSuccessDelete";
import ModalFailedDelete from "./ModalFailedDelete";
import { Modal } from "antd";
import { useSelector } from "react-redux";

const NotificationDelete = ({ updated_at, route, visibleDelete, id, title, handleCancel, url, setVisibleDelete }) => {
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messageFailed, setMessageFailed] = useState('');
  
  let { t } = useTranslation();
  const navigate = useNavigate();
  const { token, client_id, userId, grolog_account_id } = useSelector((state) => state.auth);
  const form = { updated_at: updated_at }

  const deleteHandler = async () => {
    let data = form;
    let tkn = token;  
    const headers = { "Authorization": tkn };
    let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;

    axios.delete(`${GROLOG_URL}/${url}/${id}?${param}`, { headers, data })
    .then(res => {
      if (res?.status === 200) {
        setSuccessModalOpen(true);
        setVisibleDelete(false)
      }
    })
    .catch((error) => {
      const errorCode =  error?.response?.status;
      
      if (errorCode === 400) {
        const errorMessage =  error?.response?.data?.payload?.message;
        
        setFailedModalOpen(true);
        setMessageFailed(errorMessage);
        setVisibleDelete(false)
      }
    })
  }

  const handleOKSuccess = () => {
    setSuccessModalOpen(false);
    navigate(route, { state: false });
  }

  const closeModalFailed = () => {
    setFailedModalOpen(false)
  }

  return (
    <>
      <ModalFailedDelete
        show={failedModalOpen}
        // onOk={closeModalFailed}
        action={closeModalFailed}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be deleted"
        description={messageFailed}
      />

      <ModalSuccessDelete
        show={successModalOpen}
        action={handleOKSuccess}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description="Your data has been deleted"
      />
      <Modal
        visible={visibleDelete}
        closable={false}
        centered={true}
        width="464px"
        footer={null}
      >
        <div className={style.ModalTitle}>Delete Data?</div>
        <div className={style.ModalSubTitle}>
          Are you sure for delete
          <br />
          {id} - {title}?
        </div>

        <div
          style={{
            justifyItems: "center",
            margin: 0,
            padding: 0,
            display: "flex",
          }}
        >
          <div className="mr-8 ml-9">
            <SecondaryButton
              text={t("Yes, delete")}
              action={() => deleteHandler()}
            />
          </div>

          <PrimaryButton
            text={t("USER_DETAIL:CANCEL")}
            action={handleCancel}
          />
        </div>
      </Modal>
    </>
  );
};

export default NotificationDelete;
